"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/internal_service.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalStreamServiceReconfigureStreamingByTicketsResponse = exports.InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds = exports.InternalStreamServiceReconfigureStreamingByTicketsRequest = exports.InternalStreamServiceGetAllStreamingVideosByEventIdResponse = exports.InternalStreamServiceGetAllStreamingVideosByEventIdRequest = exports.InternalStreamServiceCreateStreamingVideoResponse = exports.InternalStreamServiceCreateStreamingVideoRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * 現在必要な最低限必要なフィールドのみ
 *
 * @generated from message spwn.stream.v1.InternalStreamServiceCreateStreamingVideoRequest
 */
class InternalStreamServiceCreateStreamingVideoRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 配信開始時間
         *
         * @generated from field: int64 start_at = 3;
         */
        this.startAt = protobuf_1.protoInt64.zero;
        /**
         * 配信終了時間
         *
         * @generated from field: int64 end_at = 4;
         */
        this.endAt = protobuf_1.protoInt64.zero;
        /**
         * 説明
         *
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * 配信時間説明？
         *
         * @generated from field: string duration_text = 6;
         */
        this.durationText = "";
        /**
         * リンクストリーム名
         *
         * @generated from field: string linked_stream_name = 12;
         */
        this.linkedStreamName = "";
        /**
         * 優先度
         *
         * @generated from field: int32 priority = 13;
         */
        this.priority = 0;
        /**
         * ストレージパス
         *
         * @generated from field: string storage_path = 14;
         */
        this.storagePath = "";
        /**
         * サムネイル
         *
         * @generated from field: string thumbnail = 15;
         */
        this.thumbnail = "";
        /**
         * アーティストプロファイルの参照
         *
         * @generated from field: repeated string artist_profile_refs = 16;
         */
        this.artistProfileRefs = [];
        /**
         * チャットの日時
         *
         * @generated from field: int64 chat_datetime = 17;
         */
        this.chatDatetime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceCreateStreamingVideoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceCreateStreamingVideoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceCreateStreamingVideoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceCreateStreamingVideoRequest, a, b);
    }
}
exports.InternalStreamServiceCreateStreamingVideoRequest = InternalStreamServiceCreateStreamingVideoRequest;
InternalStreamServiceCreateStreamingVideoRequest.runtime = protobuf_1.proto3;
InternalStreamServiceCreateStreamingVideoRequest.typeName = "spwn.stream.v1.InternalStreamServiceCreateStreamingVideoRequest";
InternalStreamServiceCreateStreamingVideoRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "duration_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "has_vod", kind: "message", T: internal_common_pb_1.Status },
    { no: 8, name: "is_chat_enabled", kind: "message", T: internal_common_pb_1.Status },
    { no: 9, name: "is_live_commerce_enabled", kind: "message", T: internal_common_pb_1.Status },
    { no: 10, name: "is_live_event_enabled", kind: "message", T: internal_common_pb_1.Status },
    { no: 11, name: "is_open", kind: "message", T: internal_common_pb_1.Status },
    { no: 12, name: "linked_stream_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "artist_profile_refs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "chat_datetime", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceCreateStreamingVideoResponse
 */
class InternalStreamServiceCreateStreamingVideoResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配信ID
         *
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceCreateStreamingVideoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceCreateStreamingVideoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceCreateStreamingVideoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceCreateStreamingVideoResponse, a, b);
    }
}
exports.InternalStreamServiceCreateStreamingVideoResponse = InternalStreamServiceCreateStreamingVideoResponse;
InternalStreamServiceCreateStreamingVideoResponse.runtime = protobuf_1.proto3;
InternalStreamServiceCreateStreamingVideoResponse.typeName = "spwn.stream.v1.InternalStreamServiceCreateStreamingVideoResponse";
InternalStreamServiceCreateStreamingVideoResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceGetAllStreamingVideosByEventIdRequest
 */
class InternalStreamServiceGetAllStreamingVideosByEventIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceGetAllStreamingVideosByEventIdRequest, a, b);
    }
}
exports.InternalStreamServiceGetAllStreamingVideosByEventIdRequest = InternalStreamServiceGetAllStreamingVideosByEventIdRequest;
InternalStreamServiceGetAllStreamingVideosByEventIdRequest.runtime = protobuf_1.proto3;
InternalStreamServiceGetAllStreamingVideosByEventIdRequest.typeName = "spwn.stream.v1.InternalStreamServiceGetAllStreamingVideosByEventIdRequest";
InternalStreamServiceGetAllStreamingVideosByEventIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceGetAllStreamingVideosByEventIdResponse
 */
class InternalStreamServiceGetAllStreamingVideosByEventIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新した配信IDのリスト
         *
         * @generated from field: repeated spwn.stream.v1.StreamingVideo streaming_videos = 1;
         */
        this.streamingVideos = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceGetAllStreamingVideosByEventIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceGetAllStreamingVideosByEventIdResponse, a, b);
    }
}
exports.InternalStreamServiceGetAllStreamingVideosByEventIdResponse = InternalStreamServiceGetAllStreamingVideosByEventIdResponse;
InternalStreamServiceGetAllStreamingVideosByEventIdResponse.runtime = protobuf_1.proto3;
InternalStreamServiceGetAllStreamingVideosByEventIdResponse.typeName = "spwn.stream.v1.InternalStreamServiceGetAllStreamingVideosByEventIdResponse";
InternalStreamServiceGetAllStreamingVideosByEventIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "streaming_videos", kind: "message", T: internal_common_pb_1.StreamingVideo, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsRequest
 */
class InternalStreamServiceReconfigureStreamingByTicketsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * チケットIDとビデオIDのリスト
         *
         * @generated from field: repeated spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsRequest.TicketWithVideoIds tickets = 2;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceReconfigureStreamingByTicketsRequest, a, b);
    }
}
exports.InternalStreamServiceReconfigureStreamingByTicketsRequest = InternalStreamServiceReconfigureStreamingByTicketsRequest;
InternalStreamServiceReconfigureStreamingByTicketsRequest.runtime = protobuf_1.proto3;
InternalStreamServiceReconfigureStreamingByTicketsRequest.typeName = "spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsRequest";
InternalStreamServiceReconfigureStreamingByTicketsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tickets", kind: "message", T: InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsRequest.TicketWithVideoIds
 */
class InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * ビデオID
         *
         * @generated from field: repeated string video_ids = 2;
         */
        this.videoIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds, a, b);
    }
}
exports.InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds = InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds;
InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds.runtime = protobuf_1.proto3;
InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds.typeName = "spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsRequest.TicketWithVideoIds";
InternalStreamServiceReconfigureStreamingByTicketsRequest_TicketWithVideoIds.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "video_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsResponse
 */
class InternalStreamServiceReconfigureStreamingByTicketsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新したチケットIDのリスト
         *
         * @generated from field: repeated string updated_ticket_ids = 1;
         */
        this.updatedTicketIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalStreamServiceReconfigureStreamingByTicketsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalStreamServiceReconfigureStreamingByTicketsResponse, a, b);
    }
}
exports.InternalStreamServiceReconfigureStreamingByTicketsResponse = InternalStreamServiceReconfigureStreamingByTicketsResponse;
InternalStreamServiceReconfigureStreamingByTicketsResponse.runtime = protobuf_1.proto3;
InternalStreamServiceReconfigureStreamingByTicketsResponse.typeName = "spwn.stream.v1.InternalStreamServiceReconfigureStreamingByTicketsResponse";
InternalStreamServiceReconfigureStreamingByTicketsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "updated_ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=internal_service_pb.js.map